import script from "./white-list.vue?vue&type=script&lang=ts&setup=true"
export * from "./white-list.vue?vue&type=script&lang=ts&setup=true"

import "./white-list.vue?vue&type=style&index=0&id=25255cde&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-25255cde"]])

export default __exports__